import { render, staticRenderFns } from "./add-block-modal.vue?vue&type=template&id=2e4ec95a&scoped=true"
import script from "./add-block-modal.vue?vue&type=script&lang=js"
export * from "./add-block-modal.vue?vue&type=script&lang=js"
import style0 from "./add-block-modal.vue?vue&type=style&index=0&id=2e4ec95a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4ec95a",
  null
  
)

export default component.exports